import { serializeDripComponents, visualizeDripComponents } from "@/assets/utilities/tinymce/visualization/dripForm";
import { serializeCheckoutForm, visualizeCheckoutForm } from "@/assets/utilities/tinymce/visualization/checkoutForm";
import {
  serializeEmailFormComponents,
  visualizeEmailFormComponents,
} from "@/assets/utilities/tinymce/visualization/emailForm";
import {
  serializeContactFormComponent,
  visualizeContactFormComponent,
} from "@/assets/utilities/tinymce/visualization/contactForm";
import { olListCustomNumeric } from "@/assets/utilities/tinymce/visualization/olNumericList";
import {
  serializeCommentsWidget,
  visualizeCommentsWidget,
} from "@/assets/utilities/tinymce/visualization/commentsWidget";
import { serializeMultiStepQuiz, visualizeMultiStepQuiz } from "@/assets/utilities/tinymce/visualization/multiStepQuiz";
import {
  serializeMultiStepQuizV2,
  visualizeMultiStepQuizV2,
} from "@/assets/utilities/tinymce/visualization/multiStepQuizV2";
import { serializeTimer, visualizeTimer } from "./timer";
import { serializeToast, visualizeToast } from "@/assets/utilities/tinymce/visualization/toast";
import { serializeLiveChat, visualizeLiveChat } from "@/assets/utilities/tinymce/visualization/liveChat";
import { serializeLiveChatV2, visualizeLiveChatV2 } from "@/assets/utilities/tinymce/visualization/liveChatV2";
import { visualizeLiveAutoChat, serializeLiveAutoChat } from "@/assets/utilities/tinymce/visualization/liveChatAuto";
import { visualizeLiveChatMp4, serializeLiveChatMp4 } from "@/assets/utilities/tinymce/visualization/liveChatMp4";
import { visualizeLiveChatMp4V2, serializeLiveChatMp4V2 } from "@/assets/utilities/tinymce/visualization/liveChatMp4V2";
import { serializeMultiStepForm, visualizeMultiStepForm } from "@/assets/utilities/tinymce/visualization/multistepform";
import { serializeAudioForm, visualizeAudioForm } from "@/assets/utilities/tinymce/visualization/audioForm";
import { serializeBottomBar, visualizeBottomBar } from "@/assets/utilities/tinymce/visualization/bottomBar";
import { serializeCounter, visualizeCounter } from "./counter";
import { serializeCarrierNames, visualizeCarrierNames } from "@/assets/utilities/tinymce/visualization/carrierNames";
import { serializeZipCodeShortcode, visualizeZipCodeShortcode } from "@/assets/utilities/tinymce/visualization/zipCode";
import { serializeMultiStepQuizV3, visualizeMultiStepQuizV3 } from "./multiStepQuizV3";
import { serializeMultiStepQuizV4, visualizeMultiStepQuizV4 } from "./multiStepQuizV4";
import { serializeButtonsWithTextBox, visualizeButtonsWithTextBox } from "./buttonsWithTextBox";
import { serializeRingbaPhoneNumber, visualizeRingbaPhoneNumber } from "./ringbaPhoneNumber";
import { serializeAgeInputQuiz, visualizeAgeInputQuiz } from "./ageInputQuiz";
import { serializeSpinWheel, visualizeSpinWheel } from "./spinWheel";
import { serializeLiveClaimFeed, visualizeLiveClaimFeed } from "./liveClaimFeed";
import { serializeContactUsForm, visualizeContactUsForm } from "./contactUsForm";
import { serializeImageBanner, visualizeImageBanner } from "./imageBanner";
import { serializeSocialProof, visualizeSocialProof } from "./socialProof";
import { serializeSocialProofV2, visualizeSocialProofV2 } from "./socialProofV2";
import { serializeDate, visualizeDate } from "./dynamicDate";
import { serializeNewsletterBanner, visualizeNewsletterBanner } from "./newsletterBanner";
import { serializeLiveChatCTAV2, visualizeLiveChatCTAV2 } from "./liveChatCTAV2";
import { serializeNumberedSteps, visualizeNumberedSteps } from "./numberedSteps";

/**
 * Serializes shortcodes data
 * e.g.
 * <div data-multi-step-quiz-data="">
 *                  ->
 * <multistep-quiz :quiz-data=""></multistep-quiz>
 * @param {Element} content HAS TO BE PASSED BY REFERENCE TO BE MUTATED PROPERLY
 */
export const serializeDynamicComponents = content => {
  serializeDripComponents(content);
  serializeCheckoutForm(content);
  serializeEmailFormComponents(content);
  serializeContactFormComponent(content);
  olListCustomNumeric(content);
  serializeCommentsWidget(content);
  serializeMultiStepQuiz(content);
  serializeMultiStepQuizV2(content);
  serializeMultiStepQuizV3(content);
  serializeMultiStepQuizV4(content);
  serializeRingbaPhoneNumber(content);
  serializeTimer(content);
  serializeToast(content);
  serializeLiveChat(content);
  serializeLiveChatV2(content);
  serializeLiveAutoChat(content);
  serializeLiveChatMp4(content);
  serializeLiveChatMp4V2(content);
  serializeMultiStepForm(content);
  serializeAudioForm(content);
  serializeBottomBar(content);
  serializeCounter(content);
  serializeCarrierNames(content);
  serializeZipCodeShortcode(content);
  serializeButtonsWithTextBox(content);
  serializeAgeInputQuiz(content);
  serializeSpinWheel(content);
  serializeLiveClaimFeed(content);
  serializeContactUsForm(content);
  serializeImageBanner(content);
  serializeSocialProof(content);
  serializeSocialProofV2(content);
  serializeDate(content);
  serializeNewsletterBanner(content);
  serializeLiveChatCTAV2(content);
  serializeNumberedSteps(content);
};

export const visualizeDynamicComponents = content => {
  visualizeDripComponents(content);
  visualizeCheckoutForm(content);
  visualizeEmailFormComponents(content);
  visualizeContactFormComponent(content);
  visualizeCommentsWidget(content);
  visualizeMultiStepQuiz(content);
  visualizeMultiStepQuizV2(content);
  visualizeMultiStepQuizV3(content);
  visualizeMultiStepQuizV4(content);
  visualizeTimer(content);
  visualizeToast(content);
  visualizeLiveChat(content);
  visualizeLiveChatV2(content);
  visualizeLiveAutoChat(content);
  visualizeLiveChatMp4(content);
  visualizeLiveChatMp4V2(content);
  visualizeMultiStepForm(content);
  visualizeAudioForm(content);
  visualizeBottomBar(content);
  visualizeCounter(content);
  visualizeCarrierNames(content);
  visualizeZipCodeShortcode(content);
  visualizeButtonsWithTextBox(content);
  visualizeRingbaPhoneNumber(content);
  visualizeAgeInputQuiz(content);
  visualizeLiveClaimFeed(content);
  visualizeContactUsForm(content);
  visualizeImageBanner(content);
  visualizeSocialProof(content);
  visualizeSocialProofV2(content);
  visualizeDate(content);
  visualizeNewsletterBanner(content);
  visualizeLiveChatCTAV2(content);
  visualizeNumberedSteps(content);

  content.querySelectorAll(".columns, .content-box").forEach(element => {
    element.classList.add("dash-highlight");
  });
};
